import { __ } from '@wordpress/i18n';
import { Button ,Icon,  __experimentalToolsPanel as ToolsPanel, TimePicker} from '@wordpress/components';
import {VayuBlocksToggleControl} from '@vayu-blocks';
import { upload } from '@wordpress/icons';
import { MediaUpload ,URLInput } from '@wordpress/block-editor';
import { useState } from '@wordpress/element';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';

export const VayuBlocksVideo = ({ onChange, background }) => {
    const { value, backgroundKey } = background;
    const hasVideo = value?.video?.url;

    const [urlError, setUrlError] = useState(''); 

    const getTimeValue = (field) => {
        const totalSeconds = value?.video?.[field] || 0;
        return {
            hours: Math.floor((totalSeconds % 3600) / 60),
            minutes: totalSeconds % 60,
        };
    };

    const handleTimeChange = (field, timeObj) => {
        if (timeObj && timeObj.hours !== undefined && timeObj.minutes !== undefined) {
            const hours = timeObj.hours ?? 0;
            const minutes = timeObj.minutes ?? 0;
            const totalSeconds = (hours * 60) + minutes;
            updateChange(field, totalSeconds);
        }
    };

    const updateChange = (field, upvalue) => {
        let newVideo = {};
        const currentVideo = background?.value?.video || {};
        if(field === 'url'){
            newVideo = {
                ...currentVideo,
                [field]: upvalue,
                type: 'link'
            };
        }else{
            newVideo = {
                ...currentVideo,
                [field]: upvalue,
            };
        }

        const updatedValue = {
            ...background.value,
            video: newVideo,
        };

        onChange(backgroundKey, updatedValue);
    };

    const handleVideoUrlmedia  = (upvalue) => {
        const updatedValue = {
            ...background.value,
            video: {
                ...background.value?.video,
                url: upvalue,
                type: 'mp4'
            },
        };

        onChange(backgroundKey, updatedValue);
    }

    const resetAll = () => {
        const updatedValue = {
            ...background.value,
            video: {},
        };

        onChange(backgroundKey, updatedValue);
    };

    const handleVideoUrl = (inputUrl) => {

        let embedUrl = '';
        let videoType = '';

        try {
            const url = new URL(inputUrl);
            let videoId = '';

            // Common query string for autoplay, loop, controls
            const autoplayParams = 'autoplay=1&loop=1&controls=0&mute=1';

            // Handle YouTube Shorts
            if (url.pathname.includes('/shorts/')) {
                videoId = url.pathname.split('/shorts/')[1];
                if (videoId) {
                    embedUrl = `https://www.youtube.com/embed/${videoId}?${autoplayParams}&playlist=${videoId}`;
                }
                videoType = 'shorts';
            }

            // Handle YouTube (normal and shorts)
            else if (url.hostname.includes('youtube.com') || url.hostname.includes('youtu.be')) {
                videoId = url.searchParams.get('v') || url.pathname.split('/').pop();
                if (videoId) {
                    embedUrl = `https://www.youtube.com/embed/${videoId}?${autoplayParams}&playlist=${videoId}`;
                }
                videoType = 'you-tube';
            }

            // Handle Vimeo
            else if (url.hostname.includes('vimeo.com')) {
                videoId = url.pathname.split('/').pop();
                if (videoId) {
                    embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1&background=1`;
                }
                videoType = 'vimeo';
            }

            // Direct video file (mp4, webm, ogg)
            else if (url.pathname.match(/\.(mp4|webm|ogg)$/)) {
                embedUrl = `${inputUrl}#t=0.001`; // To force autoplay start in some browsers
                videoType = 'mp4';
            }

                setUrlError('');
                updateChange('url', embedUrl);
        }catch (error) {
                setUrlError(__('Invalid URL. Please enter a valid video URL.', 'vayu-blocks')); 
        }
    };

    const getUrl = () => {
        return value?.video?.url;
    }

    return (

        <>
            <div className='vb-video-input'>

                <MediaUpload
                    onSelect={(media) => {
                        if (media && media.url) {
                            handleVideoUrlmedia(media.url)
                        }
                    }}
                    allowedTypes={['video']}
                    render={({ open }) => (
                        <Button
                            onClick={open}
                            icon={<Icon icon={upload} />}
                            label={__('Upload Video', 'vayu-blocks')}
                            style={{
                                borderRadius: '4px',
                                padding: '4px',
                                width: '32px',
                                height: '32px',
                                backgroundColor: '#f0f0f0',
                            }}
                        />
                    )}
                />

                <URLInput
                    value={getUrl()}
                    onChange={(url) => handleVideoUrl(url)}
                    placeholder="Enter URL"
                />
            </div>

            {urlError && (
                <p style={{ color: 'red', marginTop: '4px', fontSize: '13px' }}>
                    {urlError}
                </p>
            )}

            {hasVideo && (
                <>
                    <div className="vb-media-preview-wrapper">
                        <ToolsPanel  resetAll={resetAll} >
                            <div className="vayu-blocks--video">
                                <iframe
                                    width="236"
                                    height="150"
                                    src={getUrl()}
                                    title="video player"
                                    frameborder="0"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                ></iframe>
                            </div>
                        </ToolsPanel>
                        
                        <div style={{ marginTop: '5px', display: 'flex', gap: '10px' }}>
                            <Button
                                 onClick={() => updateChange('url', '')}
                                style={{border:'1px solid #0000ff'}}
                            >
                                {__('Remove', 'vayu-blocks')}
                            </Button>
                        </div>

                        <div className="vb-toggle-wrapper-video" style={{marginTop:'15px',border:'1px dashed #c5b8b87a',padding:'10px'}}>
                            <div class="vayu-blcoks-timepicker-defined">
                                <TimePicker.TimeInput 
                                    label={__('Start Time', 'vayu-blocks')}
                                    value={getTimeValue('startTime') || 0}
                                     onChange={(val) => handleTimeChange('startTime', val)}
                                />

                                <TimePicker.TimeInput 
                                    label={__('End Time', 'vayu-blocks')}
                                    value={getTimeValue('endTime') || 0}
                                     onChange={(val) => handleTimeChange('endTime', val)}
                                />
                            </div>
                            
                            <VayuBlocksToggleControl
                                label={__('Play Once', 'vayu-blocks')}
                                checked={value?.video?.playOnce}
                                onChange={(value) => updateChange('playOnce',value)}
                            />

                            <VayuBlocksToggleControl
                                label={__('Play on Mobile', 'vayu-blocks')}
                                checked={value?.video?.playOnMobile}
                                onChange={(value) => updateChange('playOnMobile',value)}
                            />

                            <VayuBlocksToggleControl
                                label={__('Privacy', 'vayu-blocks')}
                                checked={value?.video?.privacy}
                                onChange={(value) => updateChange('privacy',value)}
                            />
                        
                        </div>


                    </div>
                </>
            )}        
           
        </>
    );
};

export const VideoHtml = ({ bg }) => {
	if (bg?.type !== 'video' || !bg?.video?.url) return null;

	const { video } = bg;
    const view = VayuBlocksDevice();

	const {
		url,
		type,
        playOnce,
        startTime,
        endTime,
        playOnMobile,
        privacy
	} = video;

	const commonStyle = {
		position: 'absolute',
		width: '100%',
		top: '50%',
		left: '50%',
        objectFit:'cover',
		aspectRatio: '16 / 9',
        transform:'translate(-50%, -50%)',
		zIndex: -1,
        minHeight:'100%',
	};

    const generateUrl = () => {
	    if (!url) return '';

        try {
            const parsedUrl = new URL(url);
            const isYouTube = parsedUrl.hostname.includes('youtube.com') || parsedUrl.hostname.includes('youtube-nocookie.com');

            const videoId = parsedUrl.pathname.split('/').includes('embed')
                ? parsedUrl.pathname.split('/')[parsedUrl.pathname.split('/').indexOf('embed') + 1]
                : null;

            if ((privacy === true || privacy === '1') && isYouTube) {
                parsedUrl.hostname = 'www.youtube-nocookie.com';
            }

            // 🔁 playOnce → loop toggle
            if (playOnce === true || playOnce === '1') {
                parsedUrl.searchParams.set('loop', '0');
                parsedUrl.searchParams.delete('playlist');
            } else {
                parsedUrl.searchParams.set('loop', '1');
                if (videoId) {
                    parsedUrl.searchParams.set('playlist', videoId);
                }
            }

            // ⏱️ Start & end time
            if (startTime !== undefined && startTime !== null && startTime !== '') {
                parsedUrl.searchParams.set('start', startTime);
            } else {
                parsedUrl.searchParams.delete('start');
            }

            if (endTime !== undefined && endTime !== null && endTime !== '') {
                parsedUrl.searchParams.set('end', endTime);
            } else {
                parsedUrl.searchParams.delete('end');
            }

            return parsedUrl.toString();
        } catch (e) {
            return url;
        }
    };

    const effectiveLoop = (playOnce === true || playOnce === '1') ? false : true;

    const shouldPlayVideo = playOnMobile === true || (playOnMobile !== true && view !== 'Mobile');

	return (
		<>
            {shouldPlayVideo && (
                <div style={{position: 'absolute',width: '100%',overflow: 'hidden',height: '100%',top: '50%',left: '50%',zIndex: -1,transform: 'translate(-50%, -50%)'}}>
                    {type === 'mp4' ? (
                    <video
                    	key={`${playOnce}-${url}`}
                    	autoPlay={true}
                    	loop={effectiveLoop}
                    	controls={false}
                    	muted
                    	controlsList={false}
                    	style={{...commonStyle, height:'100%'}}
                    >
                    	<source src={url} type="video/mp4" />
                    	Your browser does not support the video tag.
                    </video>
                    ) : (
                        <iframe
                            className="vb-elementor-background-video-embed"
                            frameBorder="0"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            src={generateUrl()}
                            style={commonStyle}
                        />
                    )}
                </div>
            ) }
		</>
	);
};
